import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { addAuthenticateReducers } from "./async/authenticateThunk";
import { addMeReducers } from "./async/meThunk";
import { initialState } from "./initialState";
import { addChangePasswordFirstLoginReducers } from "./async/changePasswordFirstLoginThunk";
import { logoutWithRedirect } from "./async/logoutThunk";

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setTokenAndMe: (state: any, action: PayloadAction<any>) => {
      const payload: any = action.payload;
      localStorage.setItem("token", payload.token);
      
      try {
        const authStateToPersist = {
          logged: true,
          me: payload.me,
          status: payload.me?.status || state.status,
          timestamp: Date.now()
        };
        localStorage.setItem('auth_state', JSON.stringify(authStateToPersist));
      } catch (error) {
      }
      
      return {
        ...state,
        me: payload.me,
        token: payload.token,
        logged: true,
        loading: false, 
      };
    },
    setBlank: (state: any, action: PayloadAction<any>) => {
      return {
        ...state,
        blank: action.payload,
      };
    },    
    logout: (_state: any, _action: PayloadAction<string>) => {
      localStorage.removeItem("token");
      localStorage.removeItem("auth_state");
      
      const newState = { 
        me: {
          id: null,
          name: null,
          email: null,
          numeroInscricao: null,
          cpf: null,
          cellphone: null,
          role: null,
          nameSocial: null,
          fotos: [],
          image: null,
          empresa: null
        },
        loading: false,
        logged: false,
        status: "1111",
        errorMessage: "",
        errors: [],
        token: null,
        blank: false,
        shouldRedirectToLogin: true
      };
      
      return newState;
    },
    clearRedirectFlag: (state: any) => {
      return {
        ...state,
        shouldRedirectToLogin: false
      };
    },
    setLoading: (state: any, action: PayloadAction<any>) => {
      return {
        ...state,
        loading: action.payload,
      };
    },
  },  extraReducers: (builder) => {
    addAuthenticateReducers(builder);
    addMeReducers(builder);
    addChangePasswordFirstLoginReducers(builder);
    
    // Add logout with redirect thunk
    builder.addCase(logoutWithRedirect.fulfilled, (state, action) => {
      return action.payload.newState;
    });
  },
});

export const { setTokenAndMe, setBlank, logout, setLoading, clearRedirectFlag } = authSlice.actions;
export { logoutWithRedirect } from "./async/logoutThunk";
